import { render } from "./Umum.vue?vue&type=template&id=1d90fc64"
import script from "./Umum.vue?vue&type=script&lang=js"
export * from "./Umum.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import QImg from 'quasar/src/components/img/QImg.js';
import QBtnGroup from 'quasar/src/components/btn-group/QBtnGroup.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QEditor from 'quasar/src/components/editor/QEditor.js';
import QFile from 'quasar/src/components/file/QFile.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QCardActions from 'quasar/src/components/card/QCardActions.js';
import QBadge from 'quasar/src/components/badge/QBadge.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QCard,QCardSection,QInput,QBtn,QTooltip,QSeparator,QImg,QBtnGroup,QDialog,QEditor,QFile,QIcon,QCardActions,QBadge});qInstall(script, 'directives', {ClosePopup});
